module.exports = __webpack_public_path__ + "c1b41ee0c07ab01f8ceb0702782703a8.svg";